<template>
    <section class="w-full mb-4 wrapper-bar-chart" @click="optionsUser = null">
        <section class="w-full verflow-x-auto custom-scrollbar">
            <table class="w-full pb-4 mt-1 min-w-max">
                <thead class="border-b">
                    <th class="text-sm w-72 text-left">Role Name</th>
                    <th class="text-sm w-24">Permission</th>
                    <th class="text-sm text-left">Users</th>
                    <th class="text-sm w-8 text-right">Manage Users</th>
                </thead>
                <tbody v-if="!isLoading && !loading.roles">
                    <tr class="border-b h-max" v-for="(role, index) in roles" :key="index">
                        <td class="p-3 text-sm">
                            <div class="flex flex-row items-center gap-x-2">
                                <div class="flex flex-col">
                                    <p class="text-sm">
                                        {{ role.name }}
                                    </p>
                                </div>
                            </div>
                        </td>
                        <td class="text-sm">
                            <div class="w-24 rounded-full bg-primary text-center text-white py-1 px-3">
                                {{ !role.status ? "Manage" : "View" }}
                            </div>
                        </td>
                        <td class="flex items-center p-3 text-sm">
                            <template v-if="role.users.length > 0">
                                <div class="flex items-center justify-center w-12 h-12 duration-300 border-2 border-white rounded-full shadow-md cursor-pointer hover:z-10 hover:-mt-2 bg-zinc-400"
                                    v-for="(user, i) in role.users" :style="`transform:translateX(${i !== 0 ? `-${i * 0.5}rem` : '0'
                                        })`" :key="i">
                                    <h2 class="text-white text-md">
                                        {{
                                            user?.emp_id?.emp_fullname.substr(0, 1) +
                                            user?.emp_id?.emp_fullname.substr(
                                                user?.emp_id?.emp_fullname.indexOf(" ") + 1,
                                                1
                                            )
                                        }}
                                    </h2>
                                </div>
                            </template>
                            <p v-else class="flex items-center h-12 text-gray-400">
                                No User Here
                            </p>
                        </td>
                        <!-- <td class="text-sm">
                            <div class="flex flex-row items-center gap-x-2">
                                <div class="flex items-center justify-center w-12 h-12 rounded-full shadow-md bg-zinc-400">
                                    <h2 class="text-white text-md">
                                        {{ avatarEmployee(role.name) }}
                                    </h2>
                                </div>
                            </div>
                        </td> -->
                        <td class="relative p-3 text-right">
                            <div class="w-full flex justify-end">
                                <Button class="p-3 shadow-none rotate-90 hover:bg-blue-100 text-primary rounded-full"
                                    @click.stop="optionsUser = index">
                                    <font-awesome-icon icon="fa-wrench" class="-rotate-90" />
                                </Button>
                            </div>
                            <div class="action_user text-left absolute -top-full right-16 rounded-md bg-white shadow-md w-52 md:w-max md:h-max"
                                v-if="optionsUser === index">
                                <ul class="text-sm">
                                    <li @click="modal.manageUser = true; modal.showModal = true;">Edit</li>
                                    <li @click="modal.delete = true; userid = user?._id;">
                                        Delete
                                    </li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td>Loading ...</td>
                    </tr>
                </tbody>
            </table>
            <!-- <Pagination v-if="!isLoading && roles.length" :current="page" :total="roles.length" :per-page="limit"
                @page-changed="pageChanged" /> -->
        </section>
    </section>
    <Modal :title="`${modal.manageUser ? 'Manage Users' : 'Add Users'}`" :showModal="modal.showModal" @close="
        modal.showModal = false;
    modeEdit = false;
    ">
        <template #header>
            <ChoiseCompany v-if="superAdmin" @selected:company="dataCompany = $event" :options="options"
                :dataCompany="dataCompany" />
        </template>
        <section>
            <!--actual component start-->
            <div>
                <!-- <ul class="flex justify-center items-center my-4">
                    <template v-for="(tab, index) in tabs" :key="index">
                        <li class="cursor-pointer px-4 text-gray-500 border-b-2 w-full text-center"
                            :class="activeTab === index ? 'text-primary border-primary' : ''" @click="activeTab = index"
                            v-text="tab">
                        </li>
                    </template>
                </ul> -->
                <div class="w-full">
                    <section class="mb-8">
                        <div class="p-4">
                            <h2 class="text-xl font-bold mb-2">Choose your options:</h2>
                            <div v-for="option in checkboxOptions" :key="index">
                                <CheckboxGroup :options="option" :value="selectedOptions" v-model="selectedOptions"
                                    @onBox:selected="selectedOptions = $event, console.log(selectedOptions)" />
                            </div>
                            <div class="mt-4">
                                <strong>Selected options:</strong>
                                <ul>
                                    <li v-for="(option, index) in selectedOptions" :key="index">{{ option }}</li>
                                </ul>
                            </div>
                        </div>
                    </section>
                    <section class="flex w-full justify-end">
                        <section class="flex w-52 justify-between">
                            <Button class="bg-gray-400 w-24 py-2 text-white rounded-md">
                                Close
                            </Button>
                            <Button class="bg-primary w-24 py-2 text-white rounded-md" @click="handleAddPeriodic"
                                :disabled="loadingData">
                                Save
                            </Button>
                        </section>
                    </section>
                </div>
            </div>
            <!--actual component end-->
        </section>
        <template #footer> </template>
    </Modal>
</template>

  
<script>
import Button from "../Button.vue";
import Modal from "../Modal.vue";
import CheckboxGroup from '../CheckboxGroup.vue';

export default {
    name: "RolesList",
    components: {
        Button,
        Modal,
        CheckboxGroup,
    },
    props: {
        roles: {
            type: Array,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            modal: {
                showModal: false,
                showSelect: null,
                manageUser: false,
                edit: false,
                delete: false,
            },
            optionsUser: null,
            userid: null,
            loading: {
                roles: false,
            },
            checkboxOptions: [
                {
                    label: 'settings',
                    value: 'settings',
                    children: [
                        { label: 'update info', value: 'update_info' },
                        { label: 'update appname', value: 'update_appname' },
                    ],
                    expanded: false,
                },
                {
                    label: 'product',
                    value: 'product',
                    children: [
                        { label: 'add product', value: 'add_product' },
                        { label: 'delete product', value: 'delete_product' },
                    ],
                    expanded: false,
                },
            ],
            selectedOptions: [],
        };
    },
    methods: {
        avatarEmployee(employeeFullname) {
            if (employeeFullname) {
                return (
                    employeeFullname.substr(0, 1) +
                    employeeFullname.substr(employeeFullname.indexOf(" ") + 1, 1)
                );
            }
        },
        // async handleChangeUserStatus() {
        //     this.loading.users = true;
        //     const uid = this.users[this.optionsUser]?._id;
        //     const ustatus = this.users[this.optionsUser]?.status;
        //     console.log(uid);
        //     const response = await SwitchUserStatus({
        //         userId: uid,
        //         status: !ustatus,
        //     });
        //     if (response?.status === 401) {
        //         this.$router.push("/login");
        //         this.toast.error(response?.data?.message);
        //         this.$store.commit("changeIsLoggedIn", false);
        //     }
        //     this.$emit("on-selected-filter", this.selectedFilter);
        //     this.loading.users = false;
        // },
        // pageChanged(event) {
        //     this.$emit("on-pagination", event);
        // },
    },
    watch: {
        selectedOptions: {
            handler: function (newData) {
                console.log(newData);
            },
        },
    },
};
</script>
  
<style scoped>
.action_user ul li {
    padding: 10px 16px;
    cursor: pointer;
    color: rgb(192, 192, 192);
}

.action_user ul li:hover {
    color: rgb(71, 166, 255);
}
</style>
  
